import { Button } from "@/components/ui/button";
import { Phone, Calendar } from "lucide-react";

export const MobileCTA = ({ show }) => {
  const scrollToBooking = () => {
    const element = document.getElementById("booking");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  if (!show) return null;

  return (
    <div
      data-testid="mobile-cta"
      className="mobile-sticky-cta md:hidden flex items-center gap-3"
    >
      <Button
        data-testid="mobile-cta-call"
        asChild
        variant="outline"
        className="flex-1 rounded-full h-12 font-semibold border-sky-200 text-sky-600"
      >
        <a href="tel:+18888801344">
          <Phone className="w-4 h-4 mr-2" />
          Call
        </a>
      </Button>
      <Button
        data-testid="mobile-cta-book"
        onClick={scrollToBooking}
        className="flex-1 rounded-full h-12 font-semibold bg-gradient-to-r from-sky-500 to-blue-600"
      >
        <Calendar className="w-4 h-4 mr-2" />
        Book Now
      </Button>
    </div>
  );
};

export default MobileCTA;
